<div class="section-container" *ngIf="office && office.agency">
  <div class="flex align-items-start justify-content-between">
    <h3>Agency Services</h3>
    <button
      *ngIf="hasRole('db-edit-offices')"
      pButton
      label="Edit Services"
      type="button"
      (click)="updateClicked()"
      class="p-button-raised p-button-warning"
      icon="pi pi-save"
      style="margin-bottom: 10px"
    ></button>
  </div>

  <p-chip *ngFor="let agencyService of office.agency.services">
    {{ agencyService.name }}
  </p-chip>
  <h4 *ngIf="!office.agency.services || office.agency.services.length === 0">No services assigned</h4>
</div>
